import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import React from "react";
import { FilteredGeographyData } from "../types";

interface LocationItem {
  name: string;
  region?: { name: string };
}

interface LocationListProps {
  title: string;
  items: LocationItem[];
  showRegion?: boolean;
}

const LocationList: React.FC<LocationListProps> = ({
  title,
  items,
  showRegion = false,
}) => {
  if (!items?.length) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="subtitle2"
        sx={{
          color: "#424242",
          mb: 1,
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>
      <List dense>
        {items.map((item, index) => (
          <ListItem key={index} sx={{ py: 0.5 }}>
            <Typography variant="body2" sx={{ fontSize: "12px" }}>
              {item.name}
              {showRegion && item.region && ` (${item.region.name})`}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export const GeographyTooltipContent: React.FC<{
  data: FilteredGeographyData;
}> = ({ data }) => {
  const { countries, regions, states } = data;

  return (
    <Box sx={{ p: 1, maxWidth: 300, minWidth: 200 }}>
      <LocationList
        title="Countries Included"
        items={countries.included.map((country) => ({
          name: country.name || "Unknown",
          region: country.region,
        }))}
        showRegion
      />
      <LocationList title="Regions Included" items={regions.included} />
      <LocationList
        title="States Included"
        items={states.included.map((state) => ({
          name: state.name || "Unknown",
        }))}
      />
      <LocationList
        title="Countries Excluded"
        items={countries.excluded.map((country) => ({
          name: country.name || "Unknown",
          region: country.region,
        }))}
        showRegion
      />
    </Box>
  );
};
